import { ReactNode } from "react"
import { Info } from "@mui/icons-material"
import { Alert } from "@mui/material"

export default function DistributionNotAvailable(): ReactNode {
  return (
    <Alert sx={{ mt: 2 }} icon={<Info fontSize="inherit" />} severity="info">
      Pre-sampling distribution unavailable as it contains non numeric (parent) value
    </Alert>
  )
}
